export default {
    regionList: {
        method: "POST",
        url: "/adminScreen/screen-user/region-list",
        name: "区域列表"
    },
    logout: {
        method: "POST",
        url: "/adminScreen/user/logout",
        name: "退出登录"
    }
};
